module.exports = __webpack_public_path__ + "img/l_s6.2e5cfb81.png";